/* OCB: SMS opt-in on the theme sign-up forms (snippets/ocb-sms-field.liquid).
   Labels written on opt-in:
   - Shopify customer tag "sms-opt-in" (added to the form's contact[tags]).
   - Klaviyo profile: phone_number, sms_opt_in=true, sms_opt_in_at, sms_opt_in_source, sms_consent_version, sms_consent_url.
   SMS_LIVE: set to true once Klaviyo has an approved sending number. Then each opt-in is also subscribed to the
   SMS List (Klaviyo records the consent and sends its confirmation text). Before that, the profile properties are the
   consent record, and sms_backfill.py subscribes those people when the number goes live. */
(function () {
  var COMPANY = 'VSXM2u', SMS_LIST = 'YgYX3r', SMS_LIVE = false;

  function e164(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    return /^[2-9]\d{2}[2-9]\d{6}$/.test(d) ? '+1' + d : null;
  }

  function post(path, body) {
    try {
      fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + COMPANY, {
        method: 'POST', keepalive: true,
        headers: { 'content-type': 'application/vnd.api+json', 'revision': '2025-07-15' },
        body: JSON.stringify(body)
      });
    } catch (err) {}
  }

  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-ocb-sms]');
    if (box && e.target.matches('[data-sms-ok]') && e.target.checked) {
      var tel = box.querySelector('[data-sms-tel]');
      if (tel) tel.focus();
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target, box = form.querySelector && form.querySelector('[data-ocb-sms]');
    if (!box || !box.querySelector('[data-sms-ok]').checked) return;
    var err = box.querySelector('[data-sms-err]'), phone = e164(box.querySelector('[data-sms-tel]').value);
    if (!phone) {
      e.preventDefault(); e.stopImmediatePropagation();
      err.hidden = false; box.querySelector('[data-sms-tel]').focus();
      return;
    }
    err.hidden = true;
    var email = ((form.querySelector('input[type=email]') || {}).value || '').trim();
    var source = box.getAttribute('data-source'), version = box.getAttribute('data-consent-version');

    var tags = form.querySelector('input[name="contact[tags]"]');
    if (tags && !/\bsms-opt-in\b/.test(tags.value)) tags.value = tags.value ? tags.value + ', sms-opt-in' : 'sms-opt-in';

    var attrs = { phone_number: phone, properties: {
      sms_opt_in: true, sms_opt_in_at: new Date().toISOString(), sms_opt_in_source: source,
      sms_consent_version: version, sms_consent_url: location.href.split('?')[0] } };
    if (email) attrs.email = email;
    post('profiles', { data: { type: 'profile', attributes: attrs } });

    if (SMS_LIVE) {
      var p = { phone_number: phone, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } };
      if (email) p.email = email;
      post('subscriptions', { data: { type: 'subscription', attributes: { custom_source: 'OCB site ' + source, profile: { data: { type: 'profile', attributes: p } } },
        relationships: { list: { data: { type: 'list', id: SMS_LIST } } } } });
    }
  }, true);
})();
